import { Pressable, Text, View } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Container = styled(Pressable, theme => {
  return {
    base: {
      paddingVertical: theme.paddingInsetOnepulse,
      paddingHorizontal: theme.paddingInsetTwopulse,
    },
    variants: {},
  }
})

export const Wrapper = styled(View, theme => {
  return {
    base: {
      minHeight: theme.sizingMediumlarge,

      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineOnepulse,

      borderRadius: theme.borderRadiusPill,
      paddingVertical: theme.paddingInsetTwopulse,

      backgroundColor: theme.colorActionFillNeutralTertiaryEnabled,
    },
    variants: {
      type: {
        single: {
          paddingHorizontal: theme.paddingInsetThreepulse,
        },
        multi: {
          paddingLeft: theme.paddingInsetOnepulse,
          paddingRight: theme.paddingInsetThreepulse,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
        },
      },
      hasDisabled: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryDisabled,
        },
      },
    },
  }
})

export const Content = styled(View, theme => {
  return {
    base: {
      flex: 1,
      gap: theme.spacingStackHalfpulse,

      backgroundColor: 'transparent',
    },
    variants: {},
  }
})

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralDefault,
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})

export const Description = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralPlaceholder,
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})

export const CheckboxContainer = styled(View, theme => {
  return {
    base: {
      padding: theme.paddingInsetTwopulse,
    },
    variants: {},
  }
})
